import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface FormShellTab {
  id: string;
  label: string;
  icon?: string;
  disabled?: boolean;
  locked?: boolean;
  lockedTitle?: string;
  required?: boolean;
  completed?: boolean;
}

@Component({
  selector: 'app-form-shell',
  templateUrl: './form-shell.component.html',
  styleUrls: ['./form-shell.component.css']
})
export class FormShellComponent {
  @Input() tabs: FormShellTab[] = [];
  @Input() activeTab: string = '';

  @Output() tabChange = new EventEmitter<string>();

  trackByTabId(index: number, tab: FormShellTab): string {
    return tab?.id ?? String(index);
  }

  onTabClick(tabId: string): void {
    if (tabId === this.activeTab) return;
    this.tabChange.emit(tabId);
  }
}

